import './new-results.styles.scss';
import { Link, useLocation } from 'react-router-dom';
import TeamSchedule from '@/components/SHARED/team-schedule/team-schedule.component';

// The games the manager chose "Show me the results" for, when there was
// more than one: every score, each linking to its game page. The games
// come from the URL (?games=id,id) so a refresh keeps the list.
const NewResults = ({ league, teams, schedule, teamId, gameLink, teamLink, base }) => {

    const location = useLocation();
    const ids = (new URLSearchParams(location.search).get('games') ?? '').split(',').filter(Boolean);
    const byId = new Map((schedule?.games ?? []).map(g => [g.id, g]));
    const games = ids.map(id => byId.get(id)).filter(g => g?.result).sort((a, b) => a.day - b.day);
    const wins = games.filter(g => (g.home === teamId ? g.result.home > g.result.away : g.result.away > g.result.home)).length;

    return (
        <div className='g-card new-results'>
            <h2>New results</h2>
            {games.length ? (
                <>
                    <p className='meta'>
                        {wins}-{games.length - wins} in these {games.length} games. Tap a score for the box score and play-by-play.
                    </p>
                    <TeamSchedule teamId={teamId} schedule={schedule} teams={teams} games={games}
                        gameLink={gameLink} teamLink={teamLink} year={league.season.year} />
                </>
            ) : (
                <p className='meta'>No results to show.</p>
            )}
            <Link to={base} className='g-button primary'>Go to My Team</Link>
        </div>
    )
}

export default NewResults
